// extracted by mini-css-extract-plugin
var _1 = "IdwellToIdwellSubMenuCompanyListItem-moduleIdwellToIdwellSubMenuCompanyListItem__eCwFg";
var _2 = "IdwellToIdwellSubMenuCompanyListItem-moduleconnectionFailedIcon__Iw6YF";
var _3 = "IdwellToIdwellSubMenuCompanyListItem-moduledisabled__Dm2Iw";
var _4 = "IdwellToIdwellSubMenuCompanyListItem-moduleselected__lZ_t3";
var _5 = "IdwellToIdwellSubMenuCompanyListItem-moduletext__hcRpY";
export { _1 as "IdwellToIdwellSubMenuCompanyListItem", _2 as "connectionFailedIcon", _3 as "disabled", _4 as "selected", _5 as "text" }
